import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pin"
const PinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 5.25C14.485 5.25 16.5 7.265 16.5 9.75S14.485 14.25 12 14.25 7.5 12.235 7.5 9.75 9.515 5.25 12 5.25M12 6.75C10.343 6.75 9 8.093 9 9.75S10.343 12.75 12 12.75 15 11.407 15 9.75 13.657 6.75 12 6.75"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12 .75C16.945.75 21 4.34 21 9.75 21 13.002 19.157 16.355 17.233 18.835 16.261 20.089 15.24 21.157 14.361 21.919 13.922 22.299 13.507 22.613 13.14 22.838 12.96 22.95 12.778 23.047 12.602 23.118 12.434 23.186 12.224 23.25 12 23.25S11.566 23.186 11.4 23.118C11.222 23.047 11.04 22.95 10.857 22.838 10.493 22.613 10.078 22.298 9.64 21.918 8.761 21.158 7.74 20.089 6.767 18.836 4.843 16.355 3 13.002 3 9.75 3 4.34 7.055.75 12 .75M12 2.25C7.833 2.25 4.5 5.218 4.5 9.75 4.5 12.498 6.094 15.52 7.952 17.915 8.87 19.099 9.825 20.093 10.622 20.785 11.022 21.13 11.37 21.39 11.643 21.559Q11.848 21.684 11.962 21.727L12 21.74 12.038 21.727Q12.152 21.683 12.357 21.56C12.63 21.39 12.977 21.13 13.377 20.785 14.176 20.093 15.13 19.099 16.049 17.915 17.906 15.52 19.5 12.498 19.5 9.75 19.5 5.218 16.167 2.25 12 2.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PinIcon
